import { Block, CodeBlock, parseProps } from "codehike/blocks";
import { Pre, highlight } from "codehike/code";
import { z } from "zod";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useEffect, useState } from "react";
import { useDarkMode } from "@/lib/store";

const Schema = Block.extend({ tabs: z.array(CodeBlock) });

export default function CodeWithTabs(props: unknown) {
  const { tabs } = parseProps(props, Schema);
  return <CodeTabs tabs={tabs} />;
}

export function CodeTabs(props: { tabs: RawCode[] }) {
  const { tabs } = props;
  const isDark = useDarkMode();
  const [highlighted, setHighlighted] = useState([]);

  async function highlightAll() {
    const result = await Promise.all(
      tabs.map((tab) => highlight(tab, isDark ? "dark-plus" : "light-plus",)),
    );
    if (result) {
      setHighlighted(result);
    }
  }

  useEffect(() => {
    highlightAll();
  }, [isDark]);

  if(!highlighted || highlighted.length == 0) return;
  
  return (
    <Tabs defaultValue={tabs[0]?.meta} className="rounded gap-0 bg-secondary">
      <TabsList className="rounded-none">
        {tabs.map((tab) => (
          <TabsTrigger key={tab.meta} value={tab.meta}>
            {tab.meta}
          </TabsTrigger>
        ))}
    
      </TabsList>
      {tabs.map((tab, i) => (
        <TabsContent key={tab.meta} value={tab.meta} className="border-t-2 ">
          <Pre code={highlighted[i]} className="m-0 rounded-none" />
        </TabsContent>
      ))}
    </Tabs>
  );
}
